const chipColors: Array<string> = [
    '#39b54a',
    '#b58239',
    '#6839b5',
    '#b53c39',
    '#393cb5'
]

export default chipColors;